import { render } from "./Quotes.vue?vue&type=template&id=1507f44a&ts=true"
import script from "./Quotes.vue?vue&type=script&lang=ts"
export * from "./Quotes.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__